module.exports = __webpack_public_path__ + "static/finalFinal-968f316b2c0dfdae35230da57a378cc8.png";